import React, { useState, useEffect, useRef } from "react";
import { captureSubmissionError } from "../../utils/sentryUtils";
import SubmittingCard from "../../components/SubmittingCard";
import SubmissionErrorCard from "../../components/SubmissionErrorCard";

const SharedOwnershipPurchaseSubmission = ({ sharedOwnershipPurchaseFlowState: flowState, onFlowComplete }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Ref guard prevents StrictMode double-mount from firing a second request
  const hasInitiated = useRef(false);

  useEffect(() => {
    if (hasInitiated.current) return;
    hasInitiated.current = true;

    fetch("/api/sharedOwnershipPurchase", {
      method: "PUT",
      body: JSON.stringify({
        formRequestId: flowState.formRequestId,
        shareDetails: flowState.shareDetails,
        housingAssociation: flowState.housingAssociation,
      }),
    })
      .then(
        async (resp) => {
          if (resp.ok) {
            setLoading(false);
            onFlowComplete();
          } else {
            const body = await resp.text().catch(() => "");
            console.error("Shared ownership purchase submission failed:", resp.status, body);
            captureSubmissionError("SharedOwnershipPurchase", resp.status, body);
            setError("Unable to process your purchase details");
            setLoading(false);
          }
        },
        (err) => {
          console.error("Shared ownership purchase submission failed:", err);
          setError("Unable to process your purchase details");
          setLoading(false);
        },
      )
      .catch((err) => {
        console.error("Shared ownership purchase submission failed:", err);
        setError("Unable to process your purchase details");
        setLoading(false);
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps -- submit once on mount; ref guard prevents StrictMode re-fire

  if (loading) {
    return <SubmittingCard />;
  }

  if (error) {
    return <SubmissionErrorCard error={error} />;
  }

  return null;
};

export default SharedOwnershipPurchaseSubmission;
